/**
 |--------------------------------------------------------------------------
 | Email : Vue-Router Routes
 |--------------------------------------------------------------------------
 */
const email = [
 // {
 //  path: '/email', component: require('pages/email/email.vue').default,
 //  name: 'email',
 //  meta: {
 //   requiresAuth: true,
 //   authLevelRequired: userLevelGroups.crm_man_ac_con,
 //   title: "Email Inbox",
 //   icon: "fas fa-inbox"
 //  }
 // },
 {
  path: '/email/:filter', component: require('pages/email/email.vue').default,
  name: 'email_inbox',
  meta: {requiresAuth: true, title: "Email Inbox", icon: "fas fa-inbox"}
 },
 // {
 //  path: '/email/create', component: require('pages/email/create.vue').default,
 //  name: 'create_email',
 //  meta: {requiresAuth: true, authLevelRequired: userLevelGroups.crm_man_ac_con, title: "New Email", icon: "fas fa-paper-plane"}
 // },
 // {
 //  path: '/email/create', component: require('pages/email/create.vue').default,
 //  name: 'create_email',
 //  meta: {
 //   requiresAuth: true,
 //   authLevelRequired: userLevelGroups.crm_man_ac_con,
 //   title: "New Email",
 //   icon: "fas fa-paper-plane"
 //  }
 // },
 {
  path: '/email', redirect: '/email/inbox', name: 'email'
 },
 {
  path: '/email/marketing/dashboard', component: require('pages/email/marketing/dashboard.vue').default,
  name: 'email_marketing_dashboard',
  meta: {requiresAuth: true, title: "Email Marketing Dashboard", icon: "fas fa-layer-group"}
 }, {
  path: '/email/marketing/create', component: require('pages/email/marketing/create.vue').default,
  name: 'email_marketing_create',
  meta: {requiresAuth: true, title: "New Email Marketing Campaign", icon: "fas fa-table"}
 }, {
  path: '/email/templates/all', component: require('pages/email/templates/all.vue').default,
  name: 'all_email_templates',
  meta: {requiresAuth: true, title: "All News Templates", icon: "fas fa-layer-group"}
 }, {
  path: '/email/templates/create', component: require('pages/email/templates/create.vue').default,
  name: 'create_email_template',
  meta: {requiresAuth: true, title: "Create News Template", icon: "fas fa-table"}
 },
];
export default email;
